import { Fold, Lens } from "@discovery/prelude/lib/control/lens";
import { _GetCustomAttributesForComponent } from "@discovery/sonic-api-ng-optics";
import * as M from "@discovery/prelude/lib/data/maybe";
import { optional, record, string, } from "@discovery/prelude/lib/data/validated";
const customAttrValidator = optional(record({
    targeting01: string,
    targeting02: string,
    targeting03: string,
    targeting04: string,
}));
const targetingAttr = optional(record({
    dplusChName: string,
    dplusGenre: string,
    dplusMindBlown: string,
    dplusShowName: string,
}));
const bannerAttr = optional(record({
    adUnitPath: string,
}));
export const AdunitPath = Fold.compose(Fold.pre(_GetCustomAttributesForComponent(bannerAttr)), M._Just(), M._Just(), Lens.prop("adUnitPath"));
export const chName = Fold.compose(Fold.pre(_GetCustomAttributesForComponent(customAttrValidator)), M._Just(), M._Just(), Lens.prop("targeting01"));
export const ShowNameM = Fold.compose(Fold.pre(_GetCustomAttributesForComponent(customAttrValidator)), M._Just(), M._Just(), Lens.prop("targeting02"));
export const GenreM = Fold.compose(Fold.pre(_GetCustomAttributesForComponent(customAttrValidator)), M._Just(), M._Just(), Lens.prop("targeting03"));
export const IsMindBlownM = Fold.compose(Fold.pre(_GetCustomAttributesForComponent(customAttrValidator)), M._Just(), M._Just(), Lens.prop("targeting04"));
export const dplusChName = Fold.compose(Fold.pre(_GetCustomAttributesForComponent(targetingAttr)), M._Just(), M._Just(), Lens.prop("dplusChName"));
export const dplusGenre = Fold.compose(Fold.pre(_GetCustomAttributesForComponent(targetingAttr)), M._Just(), M._Just(), Lens.prop("dplusGenre"));
export const dplusMindBlown = Fold.compose(Fold.pre(_GetCustomAttributesForComponent(targetingAttr)), M._Just(), M._Just(), Lens.prop("dplusMindBlown"));
export const dplusShowName = Fold.compose(Fold.pre(_GetCustomAttributesForComponent(targetingAttr)), M._Just(), M._Just(), Lens.prop("dplusShowName"));
const adSizeAttributes = optional(record({
    adSizesDesktop: string,
}));
export const AdSizeDesktop = Fold.compose(Fold.pre(_GetCustomAttributesForComponent(adSizeAttributes)), M._Just(), M._Just(), Lens.prop("adSizesDesktop"));
const adSizeMobileAttributes = optional(record({
    adSizesMobile: string,
}));
export const AdSizeMobile = Fold.compose(Fold.pre(_GetCustomAttributesForComponent(adSizeMobileAttributes)), M._Just(), M._Just(), Lens.prop("adSizesMobile"));

